import React from "react";
import { IoAlert, IoCheckmarkCircleOutline } from "react-icons/io5";
import ExitIcon from "@shared/assets/icons/ExitIcon";
import styles from "./NotificationToast.module.scss";
import { useNotificationToast } from "../model/useNotificationToast";

const NotificationToast = ({ id, message, status, removeNotification }) => {
  const { isHiding, handleRemove } = useNotificationToast(
    id,
    removeNotification,
  );

  return (
    <div
      className={`${styles.toastbg} ${
        status === 200 ? styles.success : styles.error
      } ${isHiding ? styles.hide : ""}`}
    >
      <div className={styles.toast}>
        <div className={styles.toastContent}>
          {status === 200 ? (
            <IoCheckmarkCircleOutline color="#34a853" size={22} />
          ) : (
            <IoAlert size={22} />
          )}
          <p>{message}</p>
        </div>
        <button className={styles.exit} onClick={handleRemove}>
          <ExitIcon color="white" />
        </button>
      </div>
    </div>
  );
};

export default NotificationToast;
